import { type FC } from "react";

import { SetupReviewGroup, SetupReviewNote } from "@styled/setup_review";

// Once his template changed: his sections no longer in it, and the headings he
// reworded, each a group only when there are any.
export const DraftingSetupChanges: FC<{
  removed: readonly string[];
  renamed: readonly string[];
}> = ({ removed, renamed }) => (
  <>
    {removed.length > 0 && (
      <SetupReviewGroup
        label="Removed"
        line="No longer in your template. New cases won't have them."
      >
        {removed.map((name) => (
          <SetupReviewNote key={name}>{name}</SetupReviewNote>
        ))}
      </SetupReviewGroup>
    )}
    {renamed.length > 0 && (
      <SetupReviewGroup label="Renamed" line="Your settings stay">
        {renamed.map((line) => (
          <SetupReviewNote key={line}>{line}</SetupReviewNote>
        ))}
      </SetupReviewGroup>
    )}
  </>
);
